import { Checkbox, Tooltip, Toggle, InfoIcon } from "@forge/common";
import "./css/deviceDetails.scss";
import "./css/toggleOverride.css";
import {
  getISOList,
  getListSnapshot,
  getWMKSDetails,
  removeSelectedVM,
  setLoading,
  setSelectedVM,
  setSelectedVMWare,
} from "../../../store/action";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { AppState } from "../../../../common/store/combinedReducer";
import _ from "lodash";
import { customToast } from "../../../../App";
import {
  config,
  REQUIRED_PERMISSIONS,
} from "../../../../common/authentication/config";
import { btnResponsive } from "../../academy/common/utils/helper";
import { ReplaceModel as ReplaceVMRenderer } from "./replace-vm/replace-vm";
import { hideModel, showModel } from "../../academy/store/model/model.action";
import { formatDate } from "../../../../common/utility/plantDetailUtils";

const DeviceDetails = (props: any) => {
  const dispatch = useDispatch();
  // const selectedVM = useSelector((state: AppState) => state.reducer.selectedVM);
  const selectedVMWare = useSelector(
    (state: AppState) => state.reducer.selectedVMWare,
  );
  const wmksDetails = useSelector(
    (state: AppState) => state.reducer.wmksDetails,
  );
  const wmksStatus = useSelector((state: AppState) => state.reducer.wmksStatus);
  const selectedTenant: any = useSelector(
    (state: AppState) => state.reducer.selectedTenant,
  );

  const [selectedVMData, setSelectedVMData] = useState<any>([]);
  const vmDetails = props?.vmDetails;
  const [selectedId, setId] = useState("");
  const [selectedName, setName] = useState("");
  const [openVmTab, setVmTab] = useState(false);
  const [, forceUpdate] = useState({});

  useEffect(() => {
    // Force re-render when vmDetails changes to show updated intermediateStatus
    forceUpdate({});
  }, [vmDetails]);

  useEffect(() => {
    if (props.clearAll === true) {
      vmDetails?.forEach((element: any) => {
        element.checked = false;
      });
      setSelectedVMData([]);
      props.setClearAll(false);
    }

    // Check if any VMs are actually selected
    const hasSelectedVMs =
      selectedVMData.length > 0 && _.some(vmDetails, ["checked", true]);

    if (hasSelectedVMs) {
      if (_.every(selectedVMData, ["status", "POWERED_ON"]) === true) {
        props.setRestart(false);
        props.setCreateSnapshotDisable(false);
      } else if (_.every(selectedVMData, ["status", "POWERED_OFF"]) === true) {
        props.setRestart(true);
        props.setCreateSnapshotDisable(false);
      } else if (_.every(selectedVMData, ["status", "POWERED_ON"]) === false) {
        props.setRestart(true);
        props.setCreateSnapshotDisable(false);
      }

      if (_.some(selectedVMData, ["isWindows", false])) {
        props.setShutDown(true);
      } else if (_.every(selectedVMData, ["isWindows", true])) {
        if (_.every(selectedVMData, ["status", "POWERED_ON"])) {
          props.setShutDown(false);
        } else {
          props.setShutDown(true);
        }
      }
    } else {
      props.setRestart(true);
      props.setShutDown(true);
      props.setCreateSnapshotDisable(true);
    }
  }, [vmDetails, selectedVMData, props.clearAll]);

  function getVM(
    id: string,
    name: string,
    status: string,
    isVmWindow: boolean,
    vmMetadata?: any[],
  ) {
    const openedTabs = Number(localStorage.getItem("openedTabs") || "0");
    const checkPermission = REQUIRED_PERMISSIONS.ACCESS_AND_WORK_ON_VM.every(
      (p: string) => props.plant?.permissions?.includes(p),
    );
    if (openedTabs >= 10) {
      customToast(
        "You can open a maximum of 10 nodes at a time. Please close one to open another.",
        "critical",
      );
    } else if (
      checkPermission &&
      props.plant?.name &&
      (status === "POWERED_ON" || status === "Creating Snapshot...") &&
      !openVmTab
    ) {
      setId(id);
      setName(name);
      dispatch(setSelectedVMWare({ name, id, isVmWindow }));
      if (isVmWindow) {
        const avAvailable =
          vmMetadata?.find((meta: any) => meta.key === "IsAVInstalled")
            ?.value ?? "false";
        if (avAvailable === "false") {
          props.setClicked(true);
        } else {
          props.setOpenVm(true);
        }
      } else {
        props.setOpenVm(true);
        // setVmTab(true);
      }
    }
  }

  const ReplaceModel = (props: any) => {
    const rendered: any = (ReplaceVMRenderer as any)(props);
    return typeof rendered === "string" ? <span>{rendered}</span> : rendered;
  };

  useEffect(() => {
    if (
      props.openVm &&
      selectedId !== "" &&
      !openVmTab &&
      selectedId === selectedVMWare?.id
    ) {
      dispatch(
        getWMKSDetails({
          id: selectedId,
          accessToken: localStorage.getItem("access_token"),
          siteId: props.plant?.siteId,
          orgName: props.plant?.name,
          tenantId: selectedTenant,
          orgId: selectedTenant,
        }),
      );
      setVmTab(true);
    }
  }, [props.openVm]);

  useEffect(() => {
    if (wmksDetails?.host && props.openVm && wmksStatus === 200 && openVmTab) {
      window
        .open(
          `/dashboard/${encodeURIComponent(props.plant?.name ?? "")}/${encodeURIComponent(String(props.plant?.siteId ?? ""))}/${encodeURIComponent(selectedVMWare.name ?? "")}`,
          "",
          "noopener",
        )
        ?.focus();
      localStorage.setItem(
        selectedVMWare.name,
        JSON.stringify({
          name: selectedVMWare.name,
          id: selectedId,
          siteId: props.plant?.siteId,
          orgId: props.orgId,
          orgName: props.plant?.name,
          wmksData: wmksDetails,
          isVmWindow: selectedVMWare.isVmWindow,
          tenantId: selectedTenant,
        }),
      );
      props.setOpenVm(false);
      props.setClicked(false);
      setVmTab(false);
    } else if (props.openVm && openVmTab) {
      if (wmksStatus === 409) customToast(wmksDetails?.message, "critical");
      else if (wmksStatus === 500)
        customToast(
          "Error in connection. Please try after sometime",
          "critical",
        );
      else if (wmksStatus === 401 || wmksStatus === 403)
        customToast("Unauthorized to access the vm.", "critical");
      setVmTab(false);
      props.setOpenVm(false);
      props.setClicked(false);
    }
  }, [wmksDetails, wmksStatus]);

  const validateCheckBox = (checkData: any) => {
    let checked: boolean = false;
    vmDetails?.forEach((element: any) => {
      if (element.id === checkData.id) {
        checked =
          element.checked !== undefined
            ? element.checked
            : checkData.checked !== undefined
              ? checkData.checked
              : false;
      }
    });
    return checked;
  };

  const handleCheckbox = (checked: any, data: any) => {
    const isChecked =
      typeof checked === "boolean" ? checked : checked?.target?.checked;

    vmDetails?.forEach((vm: any) => {
      if (vm.id === data.id) {
        if (isChecked) {
          vm.checked = true;
          data.checked = true;
          const val = _.uniq([...selectedVMData, vm]);
          setSelectedVMData(val);
          dispatch(setSelectedVM(vm));
        } else {
          vm.checked = false;
          data.checked = false;
          const newSelected = selectedVMData.filter(
            (cur: any) => cur.id !== data.id,
          );
          setSelectedVMData(newSelected);
          dispatch(removeSelectedVM(vm));
        }
      }
    });
  };

  const handlePower = (checked: boolean, data: any) => {
    if (props.plant && props.plant.IsVCDAlive === false) {
      customToast(
        "This site is not available currently, please try after sometime.",
        "critical",
      );
      props.handleClearAll();
    } else {
      vmDetails?.forEach((vm: any) => {
        if (vm.id === data.id) {
          if (checked) {
            props.setCloseConfirmModal(true);
            props.setHeader("Power On");
            props.setContent("power on");
            props.setPoweredVm(data);
          } else {
            props.setCloseConfirmModal(true);
            props.setHeader("Power Off");
            props.setContent("power off");
            props.setPoweredVm(data);
          }
        }
      });
    }
  };

  const openReplacePopup = (data: any, vm: any) => {
    dispatch(
      showModel({
        childTemplate: () => (
          <ReplaceModel
            siteId={data?.siteId}
            accessToken={localStorage.getItem("access_token")}
            closeModel={() => dispatch(hideModel())}
            templateName={data?.name ?? ""}
            clickedVmId={vm.id}
            clickedVmName={vm.name}
            open={true}
          />
        ),
      }),
    );
  };

  return (
    <div className="vm-cards-grid">
      {vmDetails?.map((vm: any, idx: number) => {
        const vmId = vm.id || `vm-${idx}`;
        const nodeType =
          vm.vmMetadata?.find((meta: any) => meta.key === "Node Type")?.value ||
          "--";
        const version =
          vm.vmMetadata?.find((meta: any) => meta.key === "Version")?.value ||
          "--";
        const serverPatch = vm.vmMetadata?.find(
          (meta: any) => meta.key === "Server Patch",
        )?.value;
        const fteDeviceIndex = vm.vmMetadata?.find(
          (meta: any) => meta.key === "FTE Device Index",
        )?.value;
        // const templateName = vm.vmMetadata?.find((meta: any) => meta.key === 'vm.origin.name')?.value || '--';
        const isInProgress = vm.intermediateStatus !== null;
        const isFailed = vm.status === "FAILED";
        // const isPoweredOn = vm.status === 'POWERED_ON';
        // const isPoweredOff = vm.status === 'POWERED_OFF';
        const isSuspended = vm.status === "PARTIALLY_SUSPENDED" || vm.status === "SUSPENDED";
        return (
          <div
            key={vmId}
            className={isInProgress ? "vm-card vm-card-inprogress" : "vm-card"}
          >
            <div className="vm-card-header">
              <div className="vm-header-left">
                {/* <img src={courseiconImg} alt="VM Icon" className="vm-icon" /> */}
                <img
                  src="/display-dashboard-vm.svg"
                  alt=""
                  className={`vm-icon ${btnResponsive("panel-icons")}`}
                />
                <div className="vm-info">
                  <p
                    className={
                      REQUIRED_PERMISSIONS.ACCESS_AND_WORK_ON_VM.every(
                        (p: string) => props.plant?.permissions?.includes(p),
                      ) &&
                      (vm.status === "POWERED_ON" ||
                        vm.status === "Creating Snapshot...") &&
                      !openVmTab
                        ? `vm-name clickable ${vm.status === "POWERED_ON" ? "vm-powered-on" : "vm-powered-off"}`
                        : `vm-name ${vm.status === "POWERED_ON" ? "vm-powered-on" : "vm-powered-off"}`
                    }
                    onClick={() =>
                      getVM(
                        vm.id,
                        vm.name,
                        vm.status,
                        vm.isWindows,
                        vm.vmMetadata,
                      )
                    }
                  >
                    <Tooltip
                      content={vm.name || `VM_${idx + 1}`}
                      position="bottom-left"
                    >
                      <span>{vm.name || `VM_${idx + 1}`}</span>
                    </Tooltip>
                  </p>
                  <p className="vm-description">
                    <Tooltip content={version || "--"} position="bottom-left">
                      <span>{version || "--"}</span>
                    </Tooltip>
                  </p>
                </div>
              </div>
              <div className="vm-header-right">
                {isInProgress && (
                  <div className="vm-status-badge in-progress">
                    <img src="/progress.svg" alt="." />
                    <p>In-progress</p>
                  </div>
                )}
                {isFailed && (
                  <div className="vm-status-badge failed">
                    <span className="status-dot"></span>
                    <p>Failed</p>
                  </div>
                )}
                {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                  (p: string) => props.plant?.permissions?.includes(p),
                ) &&
                  (vm.status === "POWERED_ON" ||
                    vm.status === "POWERED_OFF" ||
                    vm.status === "SUSPENDED") && (
                    <div className="custom-toggle-wrapper">
                      <Tooltip
                        content={`Power Status: ${vm.status === "POWERED_ON" ? "On" : "Off"}`}
                        position="bottom"
                      >
                        <div>
                          <Toggle
                            id={`powerToggle-${vmId}`}
                            data-testid={`powerToggle-${vmId}`}
                            checked={vm.isOn}
                            disabled={vm.isIntermediate}
                            onChange={(e) => handlePower(e.target.checked, vm)}
                            className="power-status-toggle ml-2"
                            title="Power Status"
                          />
                        </div>
                      </Tooltip>
                      {vm.status === "SUSPENDED" && (
                        <span className="suspended-status-label">
                          SUSPENDED
                          <Tooltip content="Power ON to enable the suspended VM." position="bottom">
                            <InfoIcon className="suspended-info-icon" />
                          </Tooltip>
                        </span>
                      )}
                    </div>
                  )}
                {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                  (p: string) => props.plant?.permissions?.includes(p),
                ) &&
                  (vm.status === "POWERED_ON" ||
                    vm.status === "POWERED_OFF") && (
                    <div className="custom-toggle-wrapper">
                      <Checkbox
                        id={vmId}
                        checked={validateCheckBox(vm)}
                        // className="self-center"
                        onChange={(checked: any) => handleCheckbox(checked, vm)}
                      />
                    </div>
                  )}
              </div>
            </div>

            {isInProgress ? (
              <div className="overlay-inprogress">
                <span className="text-inprogress">{vm.intermediateStatus}</span>
              </div>
            ) : (
              <>
                <div className="vm-card-body">
                  {/* <div className="vm-info-item">
                <div className="vm-label">State</div>
                <div className="vm-value">
                  <StatusBadge
                    className="mr-1 text-[8px] pt-1"
                    color={isPoweredOn ? 'green' : 'gray'}
                  />
                  {vm.status || 'Unknown'}
                  {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every((p: string) => props.plant?.permissions?.includes(p)) &&
                    (vm.status === "POWERED_ON" || vm.status === "POWERED_OFF" || vm.status === "SUSPENDED") && (
                    <Toggle
                      id={`powerToggle-${vmId}`}
                      data-testid={`powerToggle-${vmId}`}
                      checked={vm.isOn}
                      disabled={vm.isIntermediate}
                      onChange={(e) => handlePower(e.target.checked, vm)}
                      className="ml-2"
                    />
                  )}
                </div>
              </div> */}
                  <div className="vm-info-item">
                    <div className="vm-label">Node Type :</div>
                    <div className="vm-value">
                      <Tooltip content={nodeType} position="bottom-left">
                        <span>{nodeType}</span>
                      </Tooltip>
                    </div>
                  </div>
                  {vm.isWindows && (
                    <div className="vm-info-item">
                      <div className="vm-label">Last Restored On:</div>
                      <div className="vm-value">
                        {vm.snapshotRestored?.dateRestored
                          ? formatDate(vm.snapshotRestored?.dateRestored)
                          : "-- --"}
                      </div>
                    </div>
                  )}
                </div>

                {/* <div className="vm-card-body">
              <div className="vm-info-item">
                <div className="vm-label">Template Name</div>
                <Tooltip content={templateName} position="bottom-left">
                  <div className="vm-value">{templateName}</div>
                </Tooltip>
              </div>
              <div className="vm-info-item">
                <div className="vm-label">Version</div>
                <div className="vm-value">{version}</div>
              </div>
            </div> */}

                {serverPatch && (
                  <div className="vm-card-body">
                    <div className="vm-info-item">
                      <div className="vm-label">Server Patch :</div>
                      <div className="vm-value">{serverPatch}</div>
                    </div>
                  </div>
                )}

                {fteDeviceIndex && !vm.isWindows && (
                  <div className="vm-card-body">
                    <div className="vm-info-item">
                      <div className="vm-label">FTE Device Index:</div>
                      <div className="vm-value">{fteDeviceIndex}</div>
                    </div>
                  </div>
                )}

                {vm.isWindows && (
                  <div className="vm-card-body">
                    <div className="vm-info-item">
                      <div className="vm-label">Last Snapshot Restored:</div>
                      <div className="vm-value">
                        {vm.snapshotRestored?.snapshotName ? (
                          vm.snapshotRestored.snapshotName.length > 12 ? (
                            <Tooltip
                              content={vm.snapshotRestored.snapshotName}
                              position="bottom-left"
                            >
                              <span>
                                {vm.snapshotRestored.snapshotName.slice(0, 12) +
                                  "..."}
                              </span>
                            </Tooltip>
                          ) : (
                            <span>{vm.snapshotRestored.snapshotName}</span>
                          )
                        ) : (
                          "-- --"
                        )}
                      </div>
                    </div>
                    {/* <div className="vm-info-item">
                  <div className="vm-label">Last Restored On:</div>
                  <div className="vm-value">
                    {vm.snapshotRestored?.dateRestored
                      ? formatDate(vm.snapshotRestored?.dateRestored)
                      : "-- --"}
                  </div>
                </div> */}
                  </div>
                )}

                <div className="vm-card-footer">
                  <div className="vm-info-item">
                    <div className="vm-label">Actions :</div>
                    <div className="vm-value">
                      {vm.isWindows && REQUIRED_PERMISSIONS.CAN_VIEW_ISO.every((p: string) =>
                        props.plant?.permissions?.includes(p),
                      ) &&
                        REQUIRED_PERMISSIONS.CAN_MOUNT_ISO.every(
                          (p: string) =>
                            props.plant?.permissions?.includes(p),
                        ) && (
                          <button
                            className="vm-action-btn"
                            title="Insert Media"
                            disabled={isSuspended}
                            onClick={() => {
                              dispatch(removeSelectedVM());
                              dispatch(setLoading(true));
                              dispatch(setSelectedVM(vm));
                              dispatch(
                                getISOList({
                                  tenantId: selectedTenant,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.plant?.siteId,
                                  pageNumber: 1,
                                }),
                              );
                            }}
                          >
                            <img src="/insert-vm-media.svg" alt="" />
                          </button>
                        )}
                      {vm.isWindows && REQUIRED_PERMISSIONS.CAN_UNMOUNT_ISO.every(
                        (p: string) => props.plant?.permissions?.includes(p),
                      ) && (
                        <button
                          className="vm-action-btn"
                          title="Eject Media"
                          disabled={isSuspended}
                          onClick={() => {
                            dispatch(removeSelectedVM());
                            props.setHeader("Eject Media");
                            props.setCloseConfirmModal(true);
                            dispatch(setSelectedVM(vm));
                          }}
                        >
                          <img src="/eject-vm-snapshot.svg" alt="" />
                        </button>
                      )}
                      {vm.isWindows && REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                        (p: string) => props.plant?.permissions?.includes(p),
                      ) && (
                        <button
                          className="vm-action-btn"
                          title="Create Snapshot"
                          disabled={isSuspended}
                          onClick={() => {
                            if (
                              props.plant &&
                              props.plant.IsVCDAlive === false
                            ) {
                              customToast(
                                "This site is not available currently, please try after sometime.",
                                "critical",
                              );
                            } else {
                              dispatch(removeSelectedVM());
                              dispatch(setLoading(true));
                              props.setHeader("Create Snapshot");
                              props.setContent("create snapshot for");
                              dispatch(
                                getListSnapshot({
                                  orgId: props.orgId,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.plant?.siteId,
                                  vmId: vm.id,
                                }),
                              );
                              dispatch(setSelectedVM(vm));
                            }
                          }}
                        >
                          <div className="vm-action-icon-wrapper">
                            <img src="/create-vm-snapshot.svg" alt="" />
                            <img
                              src="/display-dashboard-vm.svg"
                              alt=""
                              className="vm-action-icon-overlay"
                            />
                          </div>
                        </button>
                      )}
                      {vm.isWindows && REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                        (p: string) => props.plant?.permissions?.includes(p),
                      ) && (
                        <button
                          className="vm-action-btn"
                          title="Restore Snapshot"
                          disabled={vm.snapshot === false || isSuspended}
                          onClick={() => {
                            if (
                              props.plant &&
                              props.plant.IsVCDAlive === false
                            ) {
                              customToast(
                                "This site is not available currently, please try after sometime.",
                                "critical",
                              );
                            } else {
                              dispatch(removeSelectedVM());
                              dispatch(setLoading(true));
                              props.setHeader("Restore Snapshot");
                              props.setContent("restore snapshot for");
                              dispatch(
                                getListSnapshot({
                                  orgId: props.orgId,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.plant?.siteId,
                                  vmId: vm.id,
                                }),
                              );
                              dispatch(setSelectedVM(vm));
                            }
                          }}
                        >
                          <div className="vm-action-icon-wrapper">
                            <img src="/create-vm-snapshot.svg" alt="" />
                            <img
                              src="/restore-vm-snapshot.svg"
                              alt=""
                              className="vm-action-icon-overlay"
                            />
                          </div>
                        </button>
                      )}
                      {vm.isWindows && REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                        (p: string) => props.plant?.permissions?.includes(p),
                      ) && (
                        <button
                          className="vm-action-btn"
                          title="Delete Snapshot"
                          disabled={vm.snapshot === false || isSuspended}
                          onClick={() => {
                            if (
                              props.plant &&
                              props.plant.IsVCDAlive === false
                            ) {
                              customToast(
                                "This site is not available currently, please try after sometime.",
                                "critical",
                              );
                            } else {
                              dispatch(removeSelectedVM());
                              dispatch(setLoading(true));
                              props.setHeader("Delete Snapshot");
                              props.setContent("delete snapshot for");
                              dispatch(
                                getListSnapshot({
                                  orgId: props.orgId,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.plant?.siteId,
                                  vmId: vm.id,
                                }),
                              );
                              dispatch(setSelectedVM(vm));
                            }
                          }}
                        >
                          <div className="vm-action-icon-wrapper">
                            <img src="/create-vm-snapshot.svg" alt="" />
                            <img
                              src="/delete-vm-snapshot.svg"
                              alt=""
                              className="vm-action-icon-overlay"
                            />
                          </div>
                        </button>
                      )}
                      {REQUIRED_PERMISSIONS.CAN_MOUNT_ISO.every((p: string) =>
                        props.plant?.permissions?.includes(p),
                      ) &&
                        selectedTenant === config.ACADEMY_TENANT_ID && (
                          <button
                            className="vm-action-btn"
                            title="Replace VM"
                            disabled={isSuspended || !props.plant?.permissions?.includes(REQUIRED_PERMISSIONS.ACA_HONEYWELL_TRAINING_ADMIN_DASHBOARD[0])}
                            onClick={() => {
                              openReplacePopup(props.plant, vm);
                              props.setHeader("Replace VM");
                            }}
                          >
                            <img src="/replace-vm.svg" alt="" />
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DeviceDetails;
